/**
 * @file HardwareCoCreation
 * @author wanzhongyun
 */

import React from 'react';
import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import HardwareCoCreationHook from './HardwareCoCreationHook';
import Banner from './components/banner/Banner';
import CoreStrengths from './components/coreStrengths/CoreStrengths';
import CPCooperationCase from './components/CPCooperationCase/CPCooperationCase';
import CooperationProcess from './components/cooperationProcess/CooperationProcess';
import Partner from './components/partner/Partner';
const HardwareCoCreation: React.FC = () => {

    const {
        data
    } = HardwareCoCreationHook();


    return (
        <div>
            <Header />
            {/* banner */}
            <Banner {...data.hardwareCoCreationBanner} />
            {/* 核心优势 */}
            <CoreStrengths {...data.coreStrengths} />
            {/* 共创计划合作案例 */}
            <CPCooperationCase {...data.CPCooperationCase} />
            {/* 合作伙伴 */}
            <Partner {...data.partners} />
            {/* 共创计划合作流程 */}
            <CooperationProcess {...data.cooperationProcess} />
            <Footer />
        </div>
    );
};

export default React.memo(HardwareCoCreation);
